
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFuse02Off as ObiFuse02OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fuse-02-off.js';
 
 
 

 
 export const ObiFuse02Off = createComponent({
   react: React,
   tagName: 'obi-fuse-02-off',
   elementClass: ObiFuse02OffElement,
   events: {
     
   }
  });
 
 